import { render, staticRenderFns } from "./CodesView.vue?vue&type=template&id=48d7d1d3&"
import script from "./CodesView.vue?vue&type=script&lang=ts&"
export * from "./CodesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports